const initApi = (token) => {
  return {
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': process.env.REACT_APP_READYPLAYER_API_KEY,
    },
  }
}

export const fetchToken = async (userId, partner) => {
  try {
    if (!userId || !partner) return null

    const apiOptions = initApi()
    const response = await fetch(
      `${process.env.REACT_APP_READYPLAYER_API_URL}/v1/auth/token?userId=${userId}&partner=${partner}`,
      {
        ...apiOptions,
        method: 'GET',
      }
    )

    const data = await response.json()

    if (!response.ok) {
      console.error(data.error)
      return
    }

    return data.data.token
  } catch (e) {
    console.error(e)
  }
}

export const fetchAvatarMetadata = async (avatarId) => {
  try {
    if (!avatarId) return null
    const response = await fetch(
      `https://models.readyplayer.me/${avatarId}.json`
    )
    if (!response.ok) {
      console.error('Avatar metadata not found')
      return null
    }
    const metadata = await response.json()
    return metadata
  } catch (error) {
    console.error('Error fetching avatar metadata:', error)
    return null
  }
}
